export default "__VITE_ASSET__DMFSGhWu__"